import QaDynamicSelect from "./dynamicSelect";
import GereList from "./GereLista";
export { QaDynamicSelect, GereList };
